export default "__VITE_ASSET__Bfb8N3f6__"